import { getEquipmentTypeWeightUtil } from '../../../../../modules/weight/utils'

function hasNoWeightExerciseUtil (exercise) {
  if (!exercise) {
    return
  }
  return !getEquipmentTypeWeightUtil(exercise)
}

export default hasNoWeightExerciseUtil
